import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-base mb-6" }
const _hoisted_2 = { class: "flex items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, " Download PDF ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, " PDF ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, " Copy to clipboard ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, " Copy ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _renderSlot(_ctx.$slots, "title")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppButton, {
        type: "secondary",
        class: "mr-2",
        onClick: _ctx.handleDownloadPdf
      }, {
        iconBefore: _withCtx(() => [
          _createVNode(_component_DownloadIcon, { class: "mr-1 stroke-current" })
        ]),
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_AppButton, {
        type: "secondary",
        class: "mr-2",
        onClick: _ctx.handleCopyToClipboard
      }, {
        iconBefore: _withCtx(() => [
          _createVNode(_component_DownloadIcon, { class: "mr-1 stroke-current" })
        ]),
        default: _withCtx(() => [
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}